import { ShieldAlert, ExternalLink } from 'lucide-react';

export function SessionExpiredOverlay() {
  const handleRelaunch = () => {
    window.close();
    setTimeout(() => window.location.reload(), 300);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-blur-sm bg-background/80">
      <div className="flex flex-col items-center gap-6 rounded-2xl bg-background p-10 shadow-lg max-w-sm w-full mx-4">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-destructive/10">
          <ShieldAlert className="h-8 w-8 text-destructive" />
        </div>
        <div className="flex flex-col items-center gap-2 text-center">
          <h2 className="text-xl font-semibold text-foreground">세션이 만료되었어요</h2>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Cafe24 쇼핑몰 관리자에서
            <br />
            앱을 다시 실행해주세요.
          </p>
        </div>
        <div className="flex flex-col gap-2 w-full">
          <a
            href="https://eclogin.cafe24.com/Shop/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-2 w-full rounded-xl bg-primary py-3 text-sm font-medium text-primary-foreground"
          >
            Cafe24 관리자 이동
            <ExternalLink className="h-3.5 w-3.5" />
          </a>
          <button
            type="button"
            className="w-full rounded-xl bg-muted py-3 text-sm font-medium text-muted-foreground"
            onClick={handleRelaunch}
          >
            새로고침
          </button>
        </div>
      </div>
    </div>
  );
}
